import { graphql } from "~/gql";

export const UPDATE_OFFICE_LOCATIONS = graphql(/* GraphQL */ `
  mutation updateOfficeLocationsByCountry($input: OfficeLocationsUpdateInput!) {
    updateOfficeLocationsByCountry(input: $input) {
      id
      countryCode
      name
      taxLabel
      taxLevelPercent
    }
  }
`);
